import React from "react";
import "../../assets/stylesheets/sso-provider-login-modal.css";
import { translate } from "../../vendors/react-translate/ReactTranslate";
import { validateEmail } from "../../services/ApiService";
import EmailInputWrapper from "../otpComponents/EmailInputWrapper";
import { getSamlProvider } from "../../services/firebase";
import { BackIcon } from "../../assets/svg/login-icons";

class SsoProviderLoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isEmailValid: true,
      emailChecked: false,
      signInMethods: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(e) {
    const email = e.target.value;

    this.setState({ email, emailChecked: false, isEmailValid: false });
  }


  handleSubmit() {
    const email = this.state.email.trim();
    if (!email) return;

    if (!validateEmail(email)) {
      this.setState({ isEmailValid: false, emailChecked: true });
      return;
    }

    const samlProvider = getSamlProvider(email);
    if (!samlProvider) {
      this.setState({ isEmailValid: false, emailChecked: true });
      return;
    }

    this.setState({ email, isEmailValid: true, emailChecked: true });
  }

  render() {
    const { onClose,t } = this.props;
    const { email, isEmailValid, emailChecked } = this.state;

    return (
      <div className="sso-modal-wrapper">
        <div className="sso-modal-content">
          <div className="sso-content-wrapper">
          <div className="sso-content-title" style={{ fontSize: '20px', marginBottom: '10px' }}>
            {t("login.sso.title")}
          </div>
          <div className="sso-content-subtitle" style={{ fontSize: '16px', fontWeight: '400', marginBottom: '20px' }}>
            {t("login.sso.subtitle")}
          </div>
          </div>
          <div className="input-wrapper"   style={{marginBottom: '45px'}}>
            <EmailInputWrapper
             phoneOrEmail={email}
             setPhoneOrEmail={(value) =>
              this.setState({
                email: value,
                isValid: true,
                errorMessage: "",
              })}
             isValid={isEmailValid}
             t={t}
            />
            {emailChecked && !isEmailValid && (
              <div className="error-message" style={{fontSize: '12px'}}>
                {t("login.sso.error.email")}
              </div>
            )}
          </div>
          <div className="sso-btn-wrapper" style={{ margin: '10px auto 0' }}>
            <button
              onClick={this.handleSubmit}
              className="sso-submit-btn"
              style={{
                borderRadius: '11px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '500',
                backgroundImage: isEmailValid ? 'linear-gradient(to left, #42bfb4, #2bdca6)' : 'grey',
                minWidth: '280px',
                display: 'flex',
                justifyContent: 'center',
                padding: '12px',
                cursor: 'pointer'
              }}
            >
              {t("login.otp.submit")}
            </button>
          </div>
          <div
            className="sso-back-btn"
            onClick={onClose}
            style={{
              borderRadius: '11px',
              color: '#42bfb4',
              fontWeight: '500',
              cursor: 'pointer',
              marginTop: '10px',
              fontSize: '14px'
            }}
          >
            {t("login.sso.back.btn")}
            <BackIcon />

          </div>
        </div>
      </div>
    );
  }
}

export default translate("login")(SsoProviderLoginModal);
